module.exports = __webpack_public_path__ + "files/b572e1a2429014232656604241df1271.png";